import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ffd30f94"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer-copyright"
}, "©2022，厦门斯玛特思智能电气有限公司版权所有", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer-info"
}, " 电话：0592-6253630 地址：厦门市集美区软件园三期B10栋1702单元 闽ICP备2022012690号-1 ", -1));
const _hoisted_3 = [_hoisted_1, _hoisted_2];
import { watch, ref } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 's-footer',
  setup(__props) {
    const router = useRouter();
    const style = ref({});
    // 占位的高度
    const seatStyle = ref({});
    watch(() => router, () => {
      if (document.body.scrollHeight < window.screen.height) {
        style.value = {
          position: 'fixed',
          bottom: '0'
        };
        seatStyle.value = {
          height: '102px'
        };
      } else {
        style.value = {
          position: 'relative'
        };
        seatStyle.value = {
          height: '0'
        };
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "footer",
        style: _normalizeStyle(style.value)
      }, _hoisted_3, 4), _createElementVNode("div", {
        style: _normalizeStyle(seatStyle.value)
      }, null, 4)], 64);
    };
  }
};